



































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import documentUpload from '@/components/project/documentUpload.vue';
import Event from '@/utils/event';
import { getChecklist } from '@/api/project';
import { meetingUploadlist } from '@/utils/project';
import { uploadSelectList } from '@/api/document';

@Component({
  components: { documentUpload }
})
class meetingUpload extends Vue {
  @Prop()
  initChecklist;

  @Prop()
  round;

  @Prop()
  isEdit;

  @Prop()
  companyId;

  @Prop()
  meetingGoal;

  uploaded = false;
  uploading = false;

  categoryList: any[] = [];

  uploadingMap: any = {};

  async created() {
    try {
      let res = await uploadSelectList();
      if (res.code === 200) {
        this.categoryList = meetingUploadlist.map(_ => {
          let hasUploadPermission = res.data.some(permission => permission.name === _);
          return {
            name: _,
            memo: '',
            required: false,
            list: [],
            uploadingList: [],
            selectionList: [],
            uploadedFiles: [],
            hasUploadPermission
          };
        });
        this.categoryList[meetingUploadlist.length - 1].hasUploadPermission = true;
        this.uploadingMap = meetingUploadlist.reduce((map, _) => {
          map[_] = false;
          return map;
        }, {});
      }
    } catch (e) {}
  }

  @Watch('meetingGoal', { immediate: true })
  renderCheckList(meetingGoal) {
    if (meetingGoal.id) {
      getChecklist({
        meetingGoal: meetingGoal.id,
        companyId: this.companyId
      }).then(res => {
        res.data.forEach(item => {
          item.memo = '';
          // item.files = item.files.filter(file => this.deletedFileIds.indexOf(file.id) === -1);
        });
        let list = res.data;
        let { categoryList } = this;
        categoryList.forEach(item => {
          let categoryItem = list.find(_ => item.name === _.category);
          if (categoryItem) {
            item.selectionList = categoryItem.files;
            item.required = categoryItem.required;
          } else {
            item.required = false;
          }
        });
      });
    }
  }

  // @Watch('checklist', { immediate: true })
  // initSelection(initList) {
  //   debugger;
  //   let { categoryList } = this;
  //   categoryList.forEach(item => {
  //     let categoryItem = initList.find(_ => item.name === _.category);
  //     if (categoryItem) {
  //       item.selectionList = categoryItem.files;
  //       item.required = categoryItem.required;
  //     } else {
  //       item.required = false;
  //     }
  //   });
  // }

  @Watch('initChecklist', { immediate: true })
  initList(initList) {
    let { categoryList } = this;
    categoryList.forEach(item => {
      let categoryItem = initList.find(_ => item.name === _.category);
      if (categoryItem) {
        item.list = categoryItem.files;
        item.required = categoryItem.required;
        item.memo = categoryItem.memo;
      }
    });
  }

  select(category, file) {
    let selected = category.list.find(_ => _.id === file.id);
    if (!selected) {
      category.list.push(file);
    }
  }

  deleteSelected(category, file) {
    category.list = category.list.filter(_ => _.id !== file.id);
  }

  deleteUpload(category, file) {
    category.uploadingList = category.uploadingList.filter(_ => _.uid !== file.uid);
    Event.$emit(`delete${category.name}`, file);
  }

  validate() {
    let { categoryList } = this;
    let list = categoryList.reduce((list, cur) => {
      if (cur.required && !cur.list.length && !cur.uploadingList.length && !cur.memo) {
        list.push(cur.name);
      }
      return list;
    }, [] as String[]);
    if (list.length) {
      let name = list.join('、');
      this.$message.error(`${name}需有上传文档或补充说明`);
      return false;
    } else {
      return true;
    }
  }

  uploadFiles() {
    return new Promise(resolve => {
      let upCatList = this.categoryList.filter(_ => _.uploadingList.length > 0);
      let length = upCatList.length;
      if (!length) {
        resolve(true);
      }
      Event.$emit('meetingConfirm');

      Event.$on('uploaded', ({ categoryType, list }) => {
        let category = upCatList.find(_ => _.name === categoryType);
        category.uploadedFiles = list;
        length--;
        if (length === 0) {
          resolve(true);
        }
      });
    });
  }

  async getCheckList() {
    await this.uploadFiles();
    return this.categoryList
      .map(_ => {
        let { list, uploadedFiles, required, name, memo } = _;
        let files = list.concat([]);
        uploadedFiles.forEach(file => {
          files.push({
            id: file.response.data,
            name: file.name
          });
        });
        return {
          required,
          category: name,
          files,
          memo
        };
      })
      .filter(_ => _.files.length > 0 || _.memo);
  }

  upload(category) {
    if (this.isEdit) {
      this.$message.error('编辑中不可上传文件，请于项目文档中上传后在此选择');
      return;
    }
    if (!category.hasUploadPermission) {
      this.$message.error('无此类型的文档上传权限');
      return;
    }
    this.uploadingMap[category.name] = true;
  }
  close({ category, list }) {
    let categoryItem = this.categoryList.find(_ => _.name === category);
    categoryItem.uploadingList = list;
    // this.categoryList = {
    //   ...this.categoryList,

    // };
    this.uploadingMap[category] = false;
  }
}

export default meetingUpload;
